<template>
  <div
    class="wrapper pa-4"
  >
    <h1 class="d-flex mb-2">
      <span>physically-based-rendering 基于物理的渲染和照明</span>
      <VSpacer />
    </h1>
    <div class="relative full-bleed">
      <canvas
        id="scene"
        style="
          border: 1px solid;
          max-height: 65vh;width: 100%;
          "
      />
    </div>
    <p>three.js 应用程序都需要所有这六个步骤</p>
    <p>1. 初始设置</p>
    <p>2. 创建场景</p>
    <p>3. 创建相机</p>
    <p>4. 创建可见对象</p>
    <p>5. 创建渲染器</p>
    <p>6. 渲染场景</p>
    <p><a href="https://discoverthreejs.com/zh/book/first-steps/physically-based-rendering/">https://discoverthreejs.com/zh/book/first-steps/physically-based-rendering/</a></p>
  </div>
</template>

<script>
/* eslint-disable */
// 1. 初始设置 导入类
import { World } from './World12/World.js';

export default {
  data() {
    return {};
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      // Get a reference to the container element
      const container = document.querySelector('#scene');

      // 1. Create an instance of the World app
      const world = new World(container);
      
      // 2. Render the scene
      console.log(world, 'world', world.render, 'world.render');
      world.render();
    },
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

</style>